export default function BackdropLoading({ show }) {
	if (!show) return "";
	return (
		<div className="fixed top-0 left-0 flex justify-center items-center w-screen opacity-50 h-screen z-50 bg-gray-900">
			<div className={`loading z-50 ${show ? "visible" : "hidden"}`}>
				<span className="loading-span">Loading...</span>
			</div>
		</div>
	);
}
